export default __webpack_public_path__ + "static/media/twitter-icon-pink.0adfc0fa.svg";